export default __webpack_public_path__ + "static/media/Poppins-Light.4e76fe6d.woff";